import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { FaTimes } from "react-icons/fa";

const NotificationContainer = styled.div`
  position: fixed;
  top: 80px; /* Position it below the header */
  left: 50%;
  transform: translateX(-50%);
  background-color: #f44336;
  color: white;
  padding: 16px 24px;
  border-radius: 8px;
  z-index: 9999;
  display: flex;
  align-items: flex-start;
  width: auto;
  max-width: 500px;
  box-shadow: 0 4px 15px rgba(244, 67, 54, 0.4);
  animation: ${(props) =>
    props.show ? "slideDown 0.3s forwards" : "slideUp 0.3s forwards"};

  @keyframes slideDown {
    0% {
      opacity: 0;
      transform: translate(-50%, -20px);
    }
    100% {
      opacity: 1;
      transform: translate(-50%, 0);
    }
  }

  @keyframes slideUp {
    0% {
      opacity: 1;
      transform: translate(-50%, 0);
    }
    100% {
      opacity: 0;
      transform: translate(-50%, -20px);
    }
  }
`;

const NotificationContent = styled.div`
  flex: 1;
`;

const NotificationTitle = styled.h4`
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  font-weight: 600;

  svg {
    margin-right: 8px;
  }
`;

const NotificationMessage = styled.p`
  margin: 0;
  font-size: 0.9rem;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  margin-left: 16px;
  cursor: pointer;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  opacity: 0.7;
  transition: opacity 0.2s;

  &:hover {
    opacity: 1;
  }
`;

const RedPopupNotification = ({ title, message, duration = 5000, onClose }) => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(false);
      setTimeout(() => {
        if (onClose) onClose();
      }, 300); // Wait for exit animation to complete
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const handleClose = () => {
    setShow(false);
    setTimeout(() => {
      if (onClose) onClose();
    }, 300);
  };

  return (
    <NotificationContainer show={show}>
      <NotificationContent>
        <NotificationTitle>
          <FaTimes />
          {title}
        </NotificationTitle>
        <NotificationMessage>{message}</NotificationMessage>
      </NotificationContent>
      <CloseButton onClick={handleClose}>
        <FaTimes />
      </CloseButton>
    </NotificationContainer>
  );
};

export default RedPopupNotification;
